import React from "react";
import { Card } from "reactstrap";
import "../../../assets/styles/Footer/mission.css";
import "../../../assets/styles/Footer/contactUs.css";
import "../../../assets/styles/Footer/footerAbout.css";
import FooterNav from "./FooterNav";
import { Helmet } from "react-helmet";
import FootNav from "../../User_Profile/Footer/Footer-nav/FootNav";
import { useTranslation } from "react-i18next";

const Mission = () => {
  const { t } = useTranslation();
  return (
    <div style={{ background: "white" }}> 
      <Helmet>
        <meta property="og:url" content="mission.html" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="How To Make 2020 Your Best Year Yet" />
        <meta property="og:description" content="How to make the most of your time during the pandemic" />
        <meta property="og:image" content=" images/IMG_6188.jpeg" />
      </Helmet>
      <FooterNav from={"Mission"}/>
      <div className="MainContact mb-3">
        <div className="Contactheading">
          <p>{t('mission_title')}</p>
        </div>
        <div className="Mission-card-main">
          <Card className="Mission-card-customize">
            <div className="Mission-border_top"></div>
              <img
                src="/img/Rectangle139.png"
                alt="Population Globe"
                className="Mission-img"
              />
            <div className="mt-3">
              <span className="Mission-LoginHeading">{t('expanding_world')}</span>
              <p className="Mission-p">
                {t('platform_intro')}
              </p>
              <p className="Mission-p">
                {t('mission_statement')}
              </p>
              <p className="Mission-p">
                {t('plateform_use')} {t('shops_future')}
              </p>
              <p className="Mission-p">
                {t('global_contact')}
              </p>
              <p className="Mission-p">
                {t('fingertips')}
              </p>
            </div>
            {/* <LastFooter /> */}
            <footer className="px-3">
              <p>iBouge ® • {t('copyright')} © 2026 iBouge Inc. • {t('allRightsReserved')}.</p>
              <p>{t('patentNumbers')}: US D921,652; US D921,653; US D921,032; US D921,006; US D921,005; US D921,004.</p>
            </footer>
          </Card>
        </div>
      </div>
      <FootNav from={"Mission"}/>
    </div>
  );
};

export default Mission;